import { render, staticRenderFns } from "./ImgPopup.vue?vue&type=template&id=da9b9f02&scoped=true&"
import script from "./ImgPopup.vue?vue&type=script&lang=js&"
export * from "./ImgPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da9b9f02",
  null
  
)

export default component.exports